module.exports = __webpack_public_path__ + "img/Logo_bl.4a742ff0.svg";